import React from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import SoftwareTagInput from './SoftwareTagInput';
import { dedupeSoftware, hasSoftware, softwareKey } from '../utils/softwareNames';

/**
 * Mjukvaror för ett uppdrag.
 *
 * Överst snabbval: konsultens IT-lista som kryssrutor. Därunder det vanliga
 * sökfältet med fritext mot det gemensamma registret, som också visar allt
 * som är valt. Varianter som "BIM 360" och "BIM360" räknas som en mjukvara
 * med registrets först sparade stavning.
 */
export default function SoftwareChecklist({
  value = [], onChange, consultantTools = [], registry = [], onAddNew,
}) {
  const spelling = name => registry.find(r => softwareKey(r) === softwareKey(name)) || name;

  // Varje ändring sparar hela listan med registrets stavning och utan
  // varianter, så att det sparade är exakt det formuläret visar.
  const save = list => onChange(dedupeSoftware(list.map(spelling)));

  const quickPicks = dedupeSoftware(consultantTools.map(spelling));

  const toggle = name => {
    save(hasSoftware(value, name)
      ? value.filter(v => softwareKey(v) !== softwareKey(name))
      : [...value, name]);
  };

  return (
    <Box>
      {quickPicks.length > 0 && (
        <Box sx={{ mb: 1 }}>
          <Typography variant="caption" color="text.secondary" display="block">
            Snabbval från IT-listan
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
            {quickPicks.map(name => (
              <FormControlLabel
                key={softwareKey(name)}
                control={<Checkbox size="small" checked={hasSoftware(value, name)}
                  onChange={() => toggle(name)} sx={{ py: 0.25 }} />}
                label={<Typography variant="body2">{name}</Typography>}
                sx={{ m: 0, mr: 2, minWidth: 160 }}
              />
            ))}
          </Box>
        </Box>
      )}

      <SoftwareTagInput
        value={value}
        onChange={save}
        pool={registry}
        onAddNew={name => { if (onAddNew && !hasSoftware(registry, name)) onAddNew(name); }}
        label="Programvara"
        placeholder="Sök eller lägg till programvara..."
      />
    </Box>
  );
}
